import { render, staticRenderFns } from "./ApplicationsChart.vue?vue&type=template&id=2086a568&scoped=true"
import script from "./ApplicationsChart.vue?vue&type=script&lang=js"
export * from "./ApplicationsChart.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsChart.vue?vue&type=style&index=0&id=2086a568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086a568",
  null
  
)

export default component.exports